import { generateUtilityClasses } from '@mui/material';

export const menuItemContentClasses = generateUtilityClasses('MenuItemContent', [
  'root',
  'startBadge',
  'endBadge',
  'checkbox',
  'checkMark',
  'icon',
  'mainTextFrame',
  'radio',
  'subText',
  'subTextFrame',
  'suffix',
  'text',
  'body',
  'spacer',
]);
